export default __webpack_public_path__ + "static/media/ChangeTheWorld.png.webp";